if (!customElements.get("hoculus-horizontal-scroll")) {
  class HoculusHorizontalScroll extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.scrollWrapper = this.querySelector(".scroll-wrapper");
      this.leftArrow = this.querySelector(".horizontal-carousel__arrow--left");
      this.rightArrow = this.querySelector(".horizontal-carousel__arrow--right");

      if (this.leftArrow && this.rightArrow && this.scrollWrapper) {
        this.leftArrow.addEventListener("click", this.scrollLeft.bind(this));
        this.rightArrow.addEventListener("click", this.scrollRight.bind(this));
      }
    }

    scrollLeft() {
      this.scrollWrapper.scrollBy({
        left: -300,
        behavior: "smooth",
      });
    }

    scrollRight() {
      this.scrollWrapper.scrollBy({
        left: 300,
        behavior: "smooth",
      });
    }
  }

  customElements.define("hoculus-horizontal-scroll", HoculusHorizontalScroll);
}
